
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Detail">
      <action-link v-if="$route.name !== 'SimulationsOperation'" :id="getSimulation.id"></action-link>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ActionLink from '../../components/static/simulation/ActionLink.vue';
export default {
  components: { ActionLink },
  name: 'Detail',
  data() {
    return {};
  },
  mounted() {
    this.getSimulationByIdAction({ id: parseInt(this.$route.params['id'], 10) ,loaded: true});
  },
  computed: {
    ...mapGetters('simulation', ['getSimulation']),
  },
  methods: {
    ...mapActions('simulation', ['getSimulationByIdAction']),
  },
};
</script>
